import { createFileRoute } from '@tanstack/react-router'
import { AuditPage } from '@/components/audit/page'

export const Route = createFileRoute('/_app/admin/audit/')({
  component: () => <AuditPage scope="platform" />,
})
